import { render, staticRenderFns } from "./FormQuestionFreeText.vue?vue&type=template&id=22450206&"
import script from "./FormQuestionFreeText.vue?vue&type=script&lang=js&"
export * from "./FormQuestionFreeText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports